<template>
  <div class="container">
    <div class="head_box">
      <div class="head">
        <div class="logo_boxs"></div>
        <span class="cai" @click="qwer" v-if="this.qw == 2"></span>
        <div class="code">
          <img src="../../assets/newImg/code.jpg" alt="" />
        </div>
      </div>
    </div>

    <div class="navigation_box">
      <ul class="navigation" v-if="this.qw == 1">
        <li>
          <router-link :to="{ name: 'home' }" class="active_item" exact>首页</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'enterprise' }" class="active_item">企业概况</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'index' }" class="active_item">资讯中心</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'development' }" class="active_item">业务展示</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'corporateCulture' }" class="active_item">企业文化</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'manpower' }" class="active_item">投资者关系</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'contactUs' }" class="active_item">联系我们</router-link>
        </li>
      </ul>
      <div v-if="this.qw == 2">
        <!-- <div class="caidan" @click="qwer">菜单</div> -->
        <ul class="cd_bj" v-if="show">
          <li @click="sytz">
            <div class="tit">首页</div>
          </li>
          <li>
            <div class="tit">企业概况</div>
            <div class="ziym">
              <!-- <span><router-link :to="{ name: 'enterprise',query:{'name':1} }">公司概况</router-link></span>
              <span><router-link :to="{ name: 'enterprise',query:{'name':2} }">公司高管</router-link></span>
              <span><router-link :to="{ name: 'enterprise',query:{'name':3} }">组织架构</router-link></span> -->
              <span @click="qy_gk">公司概况</span>
              <span @click="qy_gg">公司高管</span>
              <span @click="qy_jg">组织架构</span>
            </div>
          </li>
          <li>
            <div class="tit">资讯中心</div>
            <div class="ziym">
              <span @click="zx_zx">资讯中心</span>
              <span @click="zx_xw">公司新闻</span>
              <span @click="zx_xy">行业新闻</span>
              <span @click="zx_mt">媒体聚焦</span>
              <!-- <span @click="zx_wd">投资者问答</span>
              <span @click="zx_gj">股价走势</span> -->
            </div>
          </li>
          <li>
            <div class="tit">业务展示</div>
            <div class="ziym">
              <span @click="yw_yh">沿海运输</span>
              <span @click="yw_yy">远洋运输</span>
              <span @click="yw_cj">长江运输</span>
              <span @click="yw_yhe">运河运输</span>
              <span @click="yw_cy">船员服务</span>
              <span @click="yw_cb">船舶管理</span>
            </div>
          </li>
          <li>
            <div class="tit">企业文化</div>
            <div class="ziym">
              <span @click="qyw_ll">文化理念</span>
              <span @click="qyw_gz">建党工作</span>
              <span @click="qyw_db">视频导播</span>
              <span @click="qyw_ry">荣誉室</span>
            </div>
          </li>
          <li @click="tzzgx">
            <div class="tit">投资者关系</div>
            <!-- <div class="ziym">
              <span @click="rl_zp">招聘信息</span>
              <span @click="rl_yg">员工培训</span>
              <span @click="rl_zc">政策法规</span>
              <span @click="rl_bg">表格下载</span>
            </div> -->
          </li>
          <li @click="lxwm">
            <div class="tit">联系我们</div>
          </li>
        </ul>
      </div>

      <p class="nowDate">{{ getNowFormatDate()}}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      show: false,
      cur: 1,
      shijian1: "",
      shijian2: "",
      shijian3: "",
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      qw: "",
      clickName: '',
    };
  },
  beforeCreate() { },
  created() {
    if (this.windowWidth > 1000) {
      this.qw = 1;
    } else if (this.windowWidth < 1000) {
      this.qw = 2;
    }
    this.shijian();
  },
  watch: {
    windowHeight(val) {
      let that = this;
      // console.log("实时屏幕高度：",val, that.windowHeight );

      // console.log(val, "实时屏幕高度：");
      // this.qq= val
    },
    windowWidth(val) {
      let that = this;
      console.log("实时屏幕宽度：", val, that.windowWidth);
      // console.log(val, "实时屏幕宽度：");
      if (that.windowWidth > 1000) {
        this.qw = 1;
      } else if (that.windowWidth < 1000) {
        this.qw = 2;
      }
    },
  },

  methods: {
    qwer() {
      this.show = !this.show;
    },
    sytz() {
      this.show = false;
      this.$router.push({ path: "/" });
    },
    lxwm() {
      this.show = false;
      this.$router.push({ path: "../contactUs" });
    },
    tzzgx() {
      this.show = false;
      this.$router.push({ path: "../manpower" });
    },
    qy_gk() {
      this.show = false;
      this.clickName = '1'
      this.$router.push({ path: "../enterprise?name=" + 1 });
      this.$emit('ck', this.clickName)
    },
    qy_gg() {
      this.show = false;
      this.clickName = '2'
      this.$router.push({ path: "../enterprise?name=" + 2 });
      this.$emit('ck', this.clickName)
    },
    qy_jg() {
      this.show = false;
      this.clickName = '3'
      this.$router.push({ path: "../enterprise?name=" + 3 });
      this.$emit('ck', this.clickName)
    },
    // 资讯中心
    zx_zx() {
      this.show = false;
      this.clickName = '1'
      this.$router.push({ path: "../index?name=" + 1 });
      this.$emit('ck', this.clickName)
    },
    zx_xw() {
      this.show = false;
      this.clickName = '2'
      this.$router.push({ path: "../index?name=" + 2 });
      this.$emit('ck', this.clickName)

    },
    zx_xy() {
      this.show = false;
      this.clickName = '3'
      this.$router.push({ path: "../index?name=" + 3 });
      this.$emit('ck', this.clickName)

    },
    zx_mt() {
      this.show = false;
      this.clickName = '4'
      this.$router.push({ path: "../index?name=" + 4 });
      this.$emit('ck', this.clickName)

    },
    zx_wd() {
      this.show = false;
      this.clickName = '5'
      this.$router.push({ path: "../index?name=" + 5 });
      this.$emit('ck', this.clickName)

    },
    zx_gj() {
      this.show = false;
      this.clickName = '6'
      this.$router.push({ path: "../index?name=" + 6 });
      this.$emit('ck', this.clickName)

    },

    // 业务展示
    yw_yh() {
      this.show = false;
      this.clickName = '0'
      this.$router.push({ path: "../development?name=" + 0 });
      this.$emit('ck', this.clickName)
    },
    yw_yy() {
      this.show = false;
      this.clickName = '1'
      this.$router.push({ path: "../development?name=" + 1 });
      this.$emit('ck', this.clickName)
    },
    yw_cj() {
      this.show = false;
      this.clickName = '2'
      this.$router.push({ path: "../development?name=" + 2 });
      this.$emit('ck', this.clickName)

    },
    yw_yhe() {
      this.show = false;
      this.clickName = '3'
      this.$router.push({ path: "../development?name=" + 3 });
      this.$emit('ck', this.clickName)

    },
    yw_cy() {
      this.show = false;
      this.clickName = '4'
      this.$router.push({ path: "../development?name=" + 4 });
      this.$emit('ck', this.clickName)

    },
    yw_cb() {
      this.show = false;
      this.clickName = '5'
      this.$router.push({ path: "../development?name=" + 5 });
      this.$emit('ck', this.clickName)

    },
    // 企业文化
    qyw_ll() {
      this.show = false;
      this.clickName = '1'
      this.$router.push({ path: "../corporateCulture?name=" + 1 });
      this.$emit('ck', this.clickName)
    },
    qyw_gz() {
      this.show = false;
      this.clickName = '2'
      this.$router.push({ path: "../corporateCulture?name=" + 2 });
      this.$emit('ck', this.clickName)
    },
    qyw_db() {
      this.show = false;
      this.clickName = '3'
      this.$router.push({ path: "../corporateCulture?name=" + 3 });
      this.$emit('ck', this.clickName)
    },
    qyw_ry() {
      this.show = false;
      this.clickName = '4'
      this.$router.push({ path: "../corporateCulture?name=" + 4 });
      this.$emit('ck', this.clickName)
    },
    // 人力资源
    rl_zp() {
      this.show = false;
      this.clickName = '1'
      this.$router.push({ path: "../manpower?name=" + 1 });
      this.$emit('ck', this.clickName)
    },
    rl_yg() {
      this.show = false;
      this.clickName = '2'
      this.$router.push({ path: "../manpower?name=" + 2 });
      this.$emit('ck', this.clickName)
    },
    rl_zc() {
      this.show = false;
      this.clickName = '3'
      this.$router.push({ path: "../manpower?name=" + 3 });
      this.$emit('ck', this.clickName)
    },
    rl_bg() {
      this.show = false;
      this.clickName = '4'
      this.$router.push({ path: "../manpower?name=" + 4 });
      this.$emit('ck', this.clickName)
    },

    getNowFormatDate() {
      let date = new Date(),
        year = date.getFullYear(), //获取完整的年份(4位)
        month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
        strDate = date.getDate() // 获取当前日(1-31)
      if (month < 10) month = `0${month}` // 如果月份是个位数，在前面补0
      if (strDate < 10) strDate = `0${strDate}` // 如果日是个位数，在前面补0

      return `${year}年${month}月${strDate}日`;
    },
    shijian() {
      this.$axios({
        method: "get",
        url: "/index.php/home/time",
      })
        .then((res) => {
          this.shijian1 = res.data.data[0];
          this.shijian2 = res.data.data[1];
          this.shijian3 = res.data.data[2];
        })
        .catch((res) => {
          console.log("1111111" + res);
        });
    },
  },
};
</script>
<style scoped>
.logo_boxs {
  width: 400px;
  height: 90px;
  /* background: url("../../assets/img/f6a240d25b6472218454a8a41550de9.png") no-repeat; */
  background: url("../../assets/img/newLogo.png") no-repeat;
  background-size: 100%;
}

.router-link-active {
  text-align: center;
  color: #134ca3;
  border-bottom: 1px solid #134ca3;
}

a {
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}

.container {
  width: 100%;
  height: 100%;
  background: url('../../assets/bj2.png') no-repeat;
  background-size: 100% 100%;
  padding-top: 15px;
  padding-bottom: 15px;
  /* position: fixed; */
  /* display: flex;
  justify-content: center;
  flex-direction: column; */
}

.head_box {
  width: 1000px;
  margin: auto;
  /* background-color: aqua; */
  /* background-color: #134ca3; */
  /* background-color: #134ca3; */
}

.head {
  /* margin-top: 2%; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* margin-left: 4vw; */
}

.logo {
  width: 80px;
  height: 80px;
}

.nowDate {
  font-size: 20px;
}

.code {
  /* flex: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 1.2vw; */
}

.code img {
  width: 80px;
  height: auto;
}

img {
  width: 100%;
  height: auto;
}

.name_box {
  /* width: 52vw; */
  margin-left: 5%;
}

.name {
  font-weight: 900;
  font-size: 20vw;
  color: #134ca3;
  letter-spacing: 5px;
}

.English {
  font-size: 14px;
  color: #134ca3;
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.navigation_box {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-between;
  width: 1000px;
  margin: auto;
  /* height: 30px; */
  margin: 0 auto;
  margin-top: 10px;
  /* margin-bottom: 10px; */
  /* margin-left: 3vw; */
}

.navigation {
  display: flex;
  /* margin-left: 5vw; */
}

.navigation li {
  text-align: center;
  font-size: 20px;
  margin-right: 20px;
  /* display: flex; */
  margin-top: -5px;
}

.navigation li a {
  /* color: #555555;  */
}

.navigation li:target {
  color: #134ca3;
  /* background: saddlebrown; */
}

.Figure {
  width: 100%;
  height: 600px;
}

.Figure img {
  width: 100%;
  height: 100%;
}

.item_box {
  font-size: 1.2vw;
  margin-top: -5px;
  margin-left: 3%;
  font-weight: 500;
}

.week {
  margin-left: 40px;
}

.liebiao li:hover {
  color: red;
  cursor: pointer;
}

@media screen and (min-width: 320px) and (max-width: 750px) {
  .head_box {
    width: 100%;
    margin: auto;
  }

  .cai {
    width: 24px;
    height: 24px;
    background: url("../../assets/caidan.png") no-repeat;
    background-size: 100%;
    margin-right: 5%;
  }

  .logo_boxs {
    margin-left: 5%;
    width: 221px;
    height: 51px;
    /* background: url("../../assets/img/f6a240d25b6472218454a8a41550de9.png") no-repeat; */
    background: url("../../assets/img/newLogo.png") no-repeat;
    background-size: 100%;
  }

  .cd_bj li {
    margin-top: 5%;
    padding-left: 2%;
  }

  .cd_bj li span {
    margin-right: 5.5%;
    line-height: 2;
  }

  .cd_bj .ziym {
    /* width: 90%; */
    width: 350px;
  }

  .tit {
    font-size: 20px;
  }

  .code {
    display: none;
  }

  .navigation_box {
    width: 100%;
  }

  .nowDate {
    display: none;
  }

  .caidan {
    width: 50px;
    background: #eee;
    /* margin-left: 5%; */
    /* padding: 2%; */
    border: 1px solid #eee;
    border-radius: 10px;
    text-align: center;
    position: relative;
  }

  .cd_bj {
    width: 100%;
    height: 100%;
    z-index: 999;
    position: absolute;
    background-color: #f5f5f5;
  }
}

/* @media screen and (max-width: 768px) {
  .navigation{ 
    margin-left: 0vw!important;
}
.navigation li{
margin-right: 5px;
}
} */
</style>



// WEBPACK FOOTER //
// src/components/haed/haed.vue